import React, { Component } from 'react'
import deleteGif from '../../../src/assets/assets_theme/img/trash-can.gif'
import blockUser from '../../../src/assets/assets_theme/img/block-user-man.png'
import approveUser from '../../../src/assets/assets_theme/img/approve-user-man.png'
import avatar1 from '../../../src/assets/assets_theme//img/avatar/1.jpg'

export class CustomModalApproveUser extends Component {

// constructor(props) {
//   super(props);
//   this.state = {
//     data: this.props.data
//   }
// }

render() {
  let data = this.props.data;
  let title = this.props.title;
  let deleteQuiz = this.props.deleteQuiz;
  return (
    <div className="modal modal-center fade" id="modal-center-approveuser" tabindex="-1">
        <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" class="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div className="modal-body">
            <h6> 
              { data.name_kh ? data.name_kh : ''} { data.name_en ? data.name_en : ''} 
              { data.title_kh ? data.title_kh : ''} { data.title_en ? data.title_en : ''}
              { data.first_name ? data.first_name : ''} { data.last_name ? data.last_name : ''} { data.nick_name ? data.nick_name : ''}
            </h6>
            {/* <img className='center' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '350px', width: '500px'}} src={blockUser} />
             */}
             <img className='center' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '350px', width: '500px'}} src={data.id_card_url? data.id_card_url : approveUser} />
            </div>
            <div className="modal-footer">
            <button type="button" className="btn btn-bold btn-pure btn-secondary" data-dismiss="modal" onClick={() => data = null}>Close</button>
            {/* <button type="button" className="btn btn-bold btn-pure btn-danger" data-dismiss="modal" onClick={this.props.blockUser}>{this.props.data.block ? 'Unblock' : 'Block'}</button> */}
            <button type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={this.props.approveUser}>{this.props.data.approve ? 'Dispprove' : 'Approve'}</button>

            {/* {data.approve == 0 && data.block == 0  && <button type="button" className="btn btn-bold btn-pure btn-info" data-dismiss="modal" onClick={this.props.approveUser}>Approve</button>} */}


            {/* <button type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={this.props.blockUser}>Block</button> */}
            </div>
        </div>
        </div>
    </div>
  )
}
}

export default CustomModalApproveUser